# Creating Panels and Buttons in OnAir Grid Mode

In OnAir grid mode, you can create panels of buttons that can have one or more triggers attached to them.

This dialog allows you to create these panels.

Grid mode supports having multiple panels to help organize your buttons.

The number of button available button slots is configurable, it is best to start with fewer slots and edit the panel later if you need more so that the buttons are as large and easy to click as possible.

The icon, description and color can all be used to help distinguish each panel from each other

## Editing a panel

You can edit a panel by navigating to OnAir > Grid, then selecting the panel you want to edit.

Once selected, press the cog icon at the top left of the Panel container

## Deleting a panel

Edit a panel as above, at the bottom left of the panel dialog press the delete button

## Adding a button to a button slot

Left click the slot you would like the button to take up

## Editing a button

Right click on a button

## Moving buttons

Drag and drop the button where you want it to go

## Add triggers to buttons

Adding a trigger to a button is essential for making the button do something (e.g play a preset if the button is pressed)

One button can have multiple triggers
